import * as types from 'store/actions/types';
import produce from 'immer';

const INITIAL_STATE = {
	roles: []
};

export default (state = INITIAL_STATE, action) =>
	produce(state, (draft) => {
		switch (action.type) {
			// ****************** CLEAR DATA ******************
			case types.CLEAR_PANEL_STATE:
				return { ...INITIAL_STATE };

			// ******************** FETCH OPERATORS ROLES ********************
			case types.FETCH_OPERATOR_ROLES:
				draft.roles = action.payload.map(({ name }) => name);
				break;

			default:
				return state;
		}
	});
